module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 /* Template for a single transfer line */ ;
__p += '\n';
 var cls = diff_value < 0 ? 'decreased' : 'increased'; ;
__p += '\n';
 var MAX_WIDTH = 90; var MIN_WIDTH = 10; ;
__p += '\n';
 var width_percent = value/max_value*(MAX_WIDTH-MIN_WIDTH)+MIN_WIDTH; ;
__p += '\n';
 if (kind == "change" && src == "changeline" ) { ;
__p += '\n<div class="trans ' +
((__t = ( value < original_baseline ? 'dec' : 'inc' )) == null ? '' : __t) +
'" data-kind="' +
((__t = ( kind )) == null ? '' : __t) +
'" id="' +
((__t = ( source.get('uniqueId') )) == null ? '' : __t) +
'" >\n  <div class="row">\n    <div class="col-xs-2 col-sm-1 transfer-list-dates">\n      <span class="transfer-list-date">' +
((__t = ( date.getDate() )) == null ? '' : __t) +
'.' +
((__t = ( date.getMonth()+1 )) == null ? '' : __t) +
'</span>\n      <span class="transfer-list-year">' +
((__t = ( date.getFullYear() )) == null ? '' : __t) +
'</span>\n    </div>\n    <div class="col-xs-8 col-sm-5 transfer-list-nums">\n      <span class="transfer-list-amount-transferred ' +
((__t = ( cls )) == null ? '' : __t) +
'" title="' +
((__t = ( value )) == null ? '' : __t) +
'">\n        ';
 if (!source.get('pending')) { ;
__p += '\n            ';
 if (diff_value>0){ ;
__p += '\n              <strong>+ ' +
((__t = ( format_full_number(diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n               אושרו כתוספת לכדי סך:\n            ';
 } else { ;
__p += '\n              <strong>- ' +
((__t = ( format_full_number(-diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n               אושרו כקיצוץ לכדי סך:\n            ';
 } ;
__p += '\n        ';
 } else { ;
__p += '\n            ';
 if (diff_value>0){ ;
__p += '\n                <strong>+ ' +
((__t = ( format_full_number(diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n                מבוקשים כתוספת לכדי סך:\n            ';
 } else { ;
__p += '\n                <strong>- ' +
((__t = ( format_full_number(-diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n                מבוקשים כקיצוץ לכדי סך:\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n        </span>\n      <h4 class="transfer-list-total">' +
((__t = ( format_full_number(value*1000) )) == null ? '' : __t) +
' ₪</h4>\n      <span class="transfer-list-diff-percent">\n        (' +
((__t = ( Math.floor(100*(value / original_baseline)) )) == null ? '' : __t) +
'% מבסיס תקציב ' +
((__t = ( source.get('year') )) == null ? '' : __t) +
')\n      </span>\n    </div>\n    <div class="col-sm-5 transfer-list-docs">\n      <div class="folded">\n        <div class="transfer-list-explanation-label">- [ דברי הסבר ] -</div>\n        <h4 class="transfer-list-explanation-title">הנדון: ' +
((__t = ( source.get('req_titles')[0] )) == null ? '' : __t) +
'</h4>\n        <div class="transfer-list-explanation-text"></div>\n      </div>\n    </div>\n    <div class="col-xs-2 col-sm-1 transfer-list-more">\n      <a href=" ' +
((__t = ( window.URLSchemeHandlerInstance.linkToTransfer(source.get('group_id'),source.get('year')) )) == null ? '' : __t) +
'">></a>\n    </div>\n    <div class="transfer-list-bar ' +
((__t = ( cls )) == null ? '' : __t) +
' ' +
((__t = ( source.get('pending')?'pending':'' )) == null ? '' : __t) +
'" style="width:' +
((__t = ( width_percent )) == null ? '' : __t) +
'%">&nbsp</div>\n  </div>\n</div>\n';
 } ;
__p += '\n\n';
 /* Template for approved budget line */ ;
__p += '\n';
 if (kind == "approved" && src == "budgetline" && !continued ) { ;
__p += '\n<div class="yearly" data-kind="' +
((__t = ( kind )) == null ? '' : __t) +
'" id="' +
((__t = ( source.get('uniqueId') )) == null ? '' : __t) +
'" >\n  <div class="row">\n    <div class="col-xs-2 col-sm-1 transfer-list-dates">\n      <span class="transfer-list-year">' +
((__t = ( date.getFullYear() )) == null ? '' : __t) +
'</span>\n    </div>\n    <div class="col-xs-10 col-sm-5 transfer-list-nums">\n      <span class="transfer-list-diff-approved ' +
((__t = ( cls )) == null ? '' : __t) +
'" title="' +
((__t = ( value )) == null ? '' : __t) +
'">\n        ';
 if (diff_value>0){ ;
__p += '\n          <strong>+ ' +
((__t = ( format_full_number(diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n          יותר\n          (' +
((__t = (Math.floor(100*(value/(value-diff_value))) )) == null ? '' : __t) +
'%)\n           מתקציב מעודכן ' +
((__t = ( date.getFullYear()-1 )) == null ? '' : __t) +
'\n        ';
 } else if (diff_value< 0){ ;
__p += '\n          <strong>- ' +
((__t = ( format_full_number(-diff_value*1000) )) == null ? '' : __t) +
' ₪</strong>\n            פחות\n            (' +
((__t = (Math.floor(100*(value/(value-diff_value))) )) == null ? '' : __t) +
'%)\n             מתקציב מעודכן ' +
((__t = ( date.getFullYear()-1 )) == null ? '' : __t) +
'\n        ';
 } else { ;
__p += '\n            <span class="transparent">…</span>\n        ';
 } ;
__p += '\n      </span>\n      <h4 class="transfer-list-amount-approved">' +
((__t = ( format_full_number(value*1000) )) == null ? '' : __t) +
' ₪</h4>\n    </div>\n    <div class="col-sm-5 transfer-list-docs">\n      <div>\n        <h4>תקציב המדינה ' +
((__t = ( date.getFullYear() )) == null ? '' : __t) +
'</h4>\n      </div>\n    </div>\n    <div class="col-xs-0 col-sd-1 transfer-list-more">\n      <!-- <a href="#transfer/' +
((__t = ( source.get('group_id') )) == null ? '' : __t) +
'/' +
((__t = ( source.get('year') )) == null ? '' : __t) +
'">more</a> -->\n    </div>\n    <div class="transfer-list-bar" style="width:' +
((__t = ( width_percent )) == null ? '' : __t) +
'%">&nbsp</div>\n  </div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/single-transfer.html
// module id = 144
// module chunks = 0